export default {
  //给queryGroupPlus 设置样式
  overflow: {
    type: String,
    default: 'unset',
  },
  // 通过【添加库存】按钮添加明细时触发反算的工具类（为null时不触发反算）
  useBackCountAddItems: {
    type: String,
    default: 'orderBackCountUtil',
  },
  store: {
    type: Object,
    default: null,
  },
  //是否在页面上
  transfer: {
    type: Boolean,
    default: false,
  },
  zIndex: {
    type: Number,
    default: 200,
  },
  //是否固定zIndex为200（默认不固定）
  fixZindex: {
    type: Boolean,
    default: false,
  },
  //弹出框标题
  title: {
    type: String,
    default: '库存选择',
  },
  //是否显示模态框
  showModal: {
    type: Boolean,
    default: true,
  },
  maskClosable: {
    type: Boolean,
    default: true,
  },
  //模态框宽度
  width: {
    type: [String, Number],
    default: '1200',
  },
  //点击确认并关闭时，禁止触发 beforeEmit
  disabledBeforeEmitSureAndClose: {
    type: Boolean,
    default: false,
  },
  //按钮名称
  sureAndClose: {
    type: String,
    default: '提交并关闭',
  },
  //按钮名称
  sureAndContinue: {
    type: String,
    default: '提交并继续',
  },
  //显示底部按钮
  showFooter: {
    type: Boolean,
    default: false,
  },
  //表格上方的删除
  removeAll: {
    type: Boolean,
    default: false,
  },
  //表格侧边的删除
  menuDeleteShow: {
    type: Boolean,
    default: false,
  },
  //后台请求接口

  urlSaveUrl: {
    type: String,
    default: '',
  },
  //保存的参数
  saveParams: {
    type: Object,
    default: () => ({}),
  },

  //------------顶部搜索-------------/
  //是否显示查询
  isShowQueryGroup: {
    type: Boolean,
    default: false,
  },
  //查询的高级查询地址
  groupSearchFormUrl: {
    type: String,
    default: '',
  },

  //表单信息是否显示
  single: {
    type: Boolean,
    default: false,
  },
  //表单信息
  popupformData: {
    type: Object,
    default: () => {},
  },
  //表单url
  popupFormItemsDefUrl: {
    type: String,
    default: '',
  },
  formItemsDef: {
    // 表单侧滑配置的表单项
    type: Array,
    default: () => [],
  },
  //--------真分页表格参数--------------/
  //是否显示底部分页
  showPage: {
    type: Boolean,
    default: true,
  },
  //是否显示选择框
  selection: {
    type: Boolean,
    default: true,
  },
  menuAddShow: {
    type: Boolean,
    default: true,
  },
  //是否显示底部按钮
  isShowFooterBtn: {
    type: Boolean,
    default: false,
  },
  //请求地址
  urlQuery: {
    type: String,
    default: '',
  },
  //请求参数
  urlQueryParamter: {
    type: Object,
    default: () => {},
  },
  //请求方法
  urlQueryMethod: {
    type: String,
    default: 'post',
  },
  //表格定义
  modelTableDefUrl: {
    type: String,
    default: '',
  },
  //表格顶部按钮
  buttonMenuListUrl: {
    type: String,
    default: '',
  },
  //行级按钮
  buttonMenuListRowUrl: {
    type: String,
    default: '',
  },
  //删除请求信息
  menuDeleteInfo: {
    type: Object,
    default: () => {
      return {
        url: '',
        method: 'post',
        param: '',
      }
    },
  },
  //是否显示 提交并继续
  isShowContinue: {
    type: Boolean,
    default: true,
  },
  pageSize: {
    type: Number,
    default: 10,
  },
  //扫码的字段
  dataAvailableKey: {
    type: String,
    default: 'amountOut',
  },
  //是否是请求的参数
  routerParams: {
    type: Object,
    default: () => ({}),
  },

  //isScan是否是扫码
  isScan: {
    type: Boolean,
    default: false,
  },
  //是否是弹窗
  isModal: {
    type: Boolean,
    default: false,
  },
  height: {
    type: [String, Number],
    default: '',
  },
  tableFixed: {
    type: Boolean,
    default: false,
  },
  //扩展传递的数据 针对手术配货
  otherData: {
    type: Object,
    default: () => ({}),
  },
  show8649Btn: {
    type: Boolean,
    default: false,
  },
}
